import PropTypes from 'prop-types'
import React from 'react'

import HobnobModal from 'components/common/HobnobModal'
import InlineLoadingIndicator from 'components/common/InlineLoadingIndicator'

import UserAvatarContainer from 'components/common/UserAvatarContainer'

import { fullName } from 'src/services/user_helpers'

import styles from './likers-modal.scss'

export default class LikersModal extends React.Component {
  _renderLiker = (liker) => {
    const { namesByUserId } = this.props

    return (
      <li key={liker.id} className={styles['liker']}>
        <UserAvatarContainer
          user={liker}
          size={34}
        />
        <div className={styles['name']}>
          {fullName(liker, namesByUserId)}
        </div>
      </li>
    )
  };

  render () {
    const { open, onClose, likers, loadingLikers } = this.props
    const visibleLikers = likers.filter((liker) => liker && liker.id)

    const containerStyles = {
      display: 'flex',
      flexDirection: 'column',
      margin: '45px auto 25px',
      maxHeight: 'calc(100vh - 70px)',
      maxWidth: '285px',
      overflow: 'hidden'
    }

    return (
      <HobnobModal show={open} onClose={onClose} containerStyles={containerStyles} title='Likers'>
        <ul className={styles['likers-list']}>
          {visibleLikers.length === 0
            ? <li className={styles['no-likers']}>No likes yet</li>
            : visibleLikers.map(this._renderLiker)}
        </ul>
        <InlineLoadingIndicator loading={loadingLikers} />
      </HobnobModal>
    )
  }
}

LikersModal.propTypes = {
  likers: PropTypes.array,
  loadingLikers: PropTypes.bool,
  namesByUserId: PropTypes.object.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/modals/LikersModal.jsx